import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const formsSlice = createSlice({
  name: "forms",
  initialState: [],
  reducers: {
    initialize(state, action) {
      let name = action.payload;
      let currentForm = state.find((form) => form.name === name);

      if (!name) return state;

      if (!currentForm) {
        return [
          ...state,
          {
            name,
            data: [],
            errors: [],
            hasChanges: false,
          },
        ];
      }

      currentForm = {
        name,
        data: [],
        errors: [],
        hasChanges: false,
      };
    },
    update(state, action) {
      let currentForm = state.find((form) => form.name === action.payload.name);

      if (!currentForm) return state;

      currentForm.data = action.payload.data;
      currentForm.errors = action.payload.errors;
      currentForm.hasChanges = action.payload.hasChanges;
    },
    delete(state, action) {
      return state.filter((form) => form.name !== action.payload);
    },
  },
});

export const useFormsSelector = (name) =>
  useSelector((state) => state.forms.find((form) => form.name === name));

export const formsActions = formsSlice.actions;
export default formsSlice.reducer;
